import styled from 'styled-components/macro'
import { commonModalStyle, commonModalContentStyle } from 'src/global/helpers'
import { settingStyles } from './Setting/styles'

export const Modal = styled.div`
  ${commonModalStyle}
  background: ${props => props.theme.pageBackground};
  border: 1px solid ${props => props.theme.border};
  transition: opacity 0.25s ease-in-out;
  color: ${props => props.theme.normalText};
  box-shadow: 0 4px 42px ${props => props.theme.shadow};
  overflow: hidden;
  width: min(700px, calc(100vw - 16px));

  .gray-box {
    box-shadow: ${props => props.theme.middleShadow} 0px 0px 6px inset;
    padding: 1px 16px;
    border-radius: 8px;
    background-color: ${props => props.theme.pageBackground}88;
  }

  .toggle-wrapper {
    padding: 0 16px;
    width: 100%;
    max-width: 520px;
    align-self: center;

    @media (max-width: 768px) {
      padding: 0 8px;
    }
  }

  button[data-variant='as-text'] {
    margin-top: 14px;
    height: auto;
    padding-left: 0;
  }

  /* An 8px gap between the toggle and the scroll area; content scrolling up fades into the grey body */
  .scroll-fade {
    position: relative;
    z-index: 1;
    height: 8px;
    flex-shrink: 0;

    /* Only over the content column, so the scrollbar at the edge stays clear */
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 16px;
      right: 16px;
      height: 24px;
      background: linear-gradient(${props => props.theme.pageBackground}, transparent);
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.2s ease;

      @media (max-width: 768px) {
        left: 8px;
        right: 8px;
      }
    }

    /* Shown only once something has scrolled under it, so the first line at rest is never dimmed */
    &.visible::after {
      opacity: 1;
    }
  }

  &.closed {
    pointer-events: none;
    opacity: 0;
  }

  .product-image-wrapper {
    height: 55px;
  }

  @media (max-width: 768px) {
    .product-image-wrapper {
      height: 35px;
    }
  }

  .map-container {
    height: 170px;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    cursor: default;
    pointer-events: none;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 8px;
      box-shadow: inset 0 0 6px ${props => props.theme.darkerShadow};
      pointer-events: none;
    }

    .address-container {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      padding: 8px;
      background: ${props => props.theme.white};
      border-bottom-right-radius: 8px;
      border-top-left-radius: 8px;
      box-shadow: 0 0px 8px ${props => props.theme.middleShadow};
      font-weight: 500;
      font-size: 14px;
    }

    .client-marker-wrapper {
      padding-right: 8px;
      pointer-events: none;

      .client-marker {
        background: ${props => props.theme.white};
        border-radius: 24px;
        border-top-left-radius: 0;
        box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.25);

        overflow: hidden;
        display: flex;
        align-items: center;
        height: 40px;
        border-bottom: 3px solid ${props => props.theme.blue};

        .client-logo {
          height: 100%;
        }

        .client-name {
          height: 100%;
          padding-left: 8px;
          padding-right: 16px;
          display: flex;
          align-items: center;
          /* border-bottom: 2px solid red; */

          font-size: 14px;
          font-weight: 500;
          font-family: 'Montserrat', sans-serif;
        }
      }
    }
  }
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 16px;
  background: ${props => props.theme.pageBackground};
  font-size: 18px;
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  position: relative;
  padding: 16px;

  @media (max-width: 768px) {
    padding: 8px;
  }

  .title {
    font-size: 22px;
    font-weight: 500;

    @media (max-width: 768px) {
      font-size: 20px;
      border: 1px solid red;
    }
  }

  .subtitle {
    color: ${props => props.theme.mutedText};
    margin: 8px 0;
    font-size: 15px;
    line-height: 18px;
    font-weight: 500;

    .fa {
      margin-right: 6px;
    }
  }

  ${settingStyles}

  .separator-wrapper {
    width: 100%;
    margin: 32px 0;

    .separator {
      width: 100%;
      border-top: 1px solid ${props => props.theme.pageBackground};
    }
  }

  .auto-save {
    text-align: center;
    font-size: 14px;
    margin-top: 24px;
    margin-bottom: 8px;
    color: ${props => props.theme.mutedText};
    font-weight: 500;

    svg {
      margin-right: 4px;
      color: ${props => props.theme.green};
      font-size: 14px;
      transition: width 0.5s cubic-bezier(0.25, 1, 0.32, 1);
    }
  }
`

export const ModalText = styled.div`
  margin-top: 24px;
  font-size: 16px;
  text-align: center;
  line-height: 22px;
  font-weight: 400;
`

export const ModalFooter = styled.div`
  border-top: 1px solid ${props => props.theme.border};
  padding: 12px;
  background: ${props => props.theme.pageBackground};
  display: flex;
  justify-content: space-around;
  align-items: center;

  button {
    margin-top: 0;
  }
`
